module.exports = __webpack_public_path__ + "89b1e7f6cee7eb59a7d92c20cf3be0a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buy-sub-img2.png
// module id = 1054
// module chunks = 0